const validators = {
    required: (value,field) => {
        return (value.length !== 0 || value === true) ? undefined :  "* Required";
    },
    mustBeEmail: (value,field) => {
        
        return  (String(value)
                .toLowerCase()
                .match(
                   /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                ) !== null)?  undefined : "* Please enter valid email";
    },
    mustBeValidPhone: (value,field) => {
        return value.length >= field.min ? undefined : `* Please enter valid phone number`;
    },
    minLength: (value,field) => {
        return value.length >= field.min ? undefined : `* The entry should be at least ${field.min} characters`;
    },
    maxLength: (value,field) => {
        return value.length <= field.max ? undefined : `* The entry shouldn't be more than ${field.max} characters`;
    },
    min: (value,field) => {
        return parseInt(value) >= field.min ? undefined : `* The entry should be bigger than ${field.min}`;
    },
    max: (value,field) => {
        return parseInt(value) <= field.max ? undefined : `* The entry should be smaller than ${field.max}`;
    },
    mustBeNumeric: (value,field) => {
        return (!isNaN(value))? undefined : "* Must be valid number";
    },
    mustMatchRegex: (value,field) => {
        return (String(value).toLowerCase().match(field.regex) !== null)?  undefined : "* Please enter valid data";
    }
}
export default validators